module.exports = __webpack_public_path__ + "assets/a047a487b7cbff6225e5f30965b350be.svg";